
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sale",
      function () {
        return require("private-next-pages/sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sale"])
      });
    }
  